/**
 * Display labels for the three quiz result statuses, used by the PDF
 * placeholder `{{Quiz.<id>}}` and by the conditional-rule pickers. Rules always
 * compare the raw status string — these are for humans only. QL-361 reworded
 * them to the business vocabulary the product-assessment sources use; the
 * stored values are unchanged.
 */

import { pickT } from "../i18n";
import type { QuizResultStatus } from "../types/quizzes";
import type { TranslationTable } from "../types/translation-table";

const QUIZ_RESULT_STATUS_LABELS: TranslationTable<Record<QuizResultStatus, string>> = {
  en_GB: { unanswered: "Not answered", passed: "Passed", failed: "Not passed" },
  nb_NO: { unanswered: "Ikke besvart", passed: "Bestått", failed: "Ikke bestått" },
};

/** Label for a status in the given language, falling back to en_GB. */
export function quizResultStatusLabel(status: QuizResultStatus, lang: string): string {
  return pickT(QUIZ_RESULT_STATUS_LABELS, lang)[status];
}
